import { createAction } from "typesafe-actions";
import { RequestState } from "../../constants/request-state";
import { Company } from "../../types/amr-pipeline/models/Company";

const requestDebtInvestors = createAction('entities/debt-investors/REQUEST', resolve => (requestState: RequestState) => resolve({ requestState}));

const responseDebtInvestors = createAction(
    'entities/debt-investors/RESPONSE',
    resolve => (requestState: RequestState, debtInvestors: Company[]) => resolve({ requestState, debtInvestors })
);

export const debtInvestorsActions = {
    requestDebtInvestors,
    responseDebtInvestors
};
